<!-- <h2 mat-dialog-title>
<mat-icon style="vertical-align: middle; margin-right: 16px">share</mat-icon>
<span>{{ 'share_dialog.title' | transloco }}</span>
</h2> -->

<div mat-dialog-title>
  <div class="title-icon">
    <mat-icon>share</mat-icon>
  </div>
  <div class="title-text">{{ 'share_dialog.title' | transloco }}</div>
</div>

<mat-dialog-content class="mat-typography">
  <form [formGroup]="form">
    @if (!showQRCode) {
      <div class="share-form-fields" style="text-align: center">
        <mat-form-field>
          <mat-label>{{ 'share_dialog.email_label' | transloco }}</mat-label>
          <input
            matInput
            [placeholder]="'share_dialog.email_placeholder' | transloco"
            formControlName="email"
            required />
          <mat-error>{{ 'share_dialog.email_error' | transloco }}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'share_dialog.password_label' | transloco }}</mat-label>
          <input
            matInput
            [placeholder]="'share_dialog.password_placeholder' | transloco"
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
            required />
          <button
            mat-icon-button
            matSuffix
            (click)="showPassword = !showPassword"
            [attr.aria-label]="'share_dialog.show_password' | transloco"
            [attr.aria-pressed]="showPassword">
            <mat-icon>
              {{ showPassword ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>{{ 'share_dialog.qr_expiration_label' | transloco }}</mat-label>
          <mat-date-range-input [rangePicker]="picker" [min]="now" >
            <input
              matStartDate
              formControlName="startDate"
              [placeholder]="'share_dialog.start_date_placeholder' | transloco" />
            <input
              matEndDate
              formControlName="endDate"
              [placeholder]="'share_dialog.end_date_placeholder' | transloco" />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"></mat-datepicker-toggle>
          <!-- Clear button integrated as a suffix -->
          <button
            mat-icon-button
            matSuffix
            [attr.aria-label]="'share_dialog.clear_dates' | transloco"
            (click)="clearDates()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        @if (this.form.errors?.dateRange) {
          <mat-error [innerHTML]="this.form.errors?.dateRange"></mat-error>
        }
        @if (this.credentialError) {
          <mat-error [innerHTML]="this.credentialError"></mat-error>
        }
      </div>
    }
  </form>

  <div class="qrcode_wrapper">
    @if (showQRCode) {
      <qrcode
        #qrCanvas
        [elementType]="elementType"
        [errorCorrectionLevel]="errorCorrectionLevel"
        [qrdata]="qrdata"
        [scale]="scale"
        [width]="width"
        [allowEmptyString]="true"
        [cssClass]="'center'"
        [margin]="margin"
        [alt]="alt"
        [ariaLabel]="ariaLabel"
        [title]="title"
        [imageSrc]="imageSrc"
        [imageHeight]="imageHeight"
        [imageWidth]="imageWidth"></qrcode>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (!showQRCode) {
    <button
      mat-button
      color="primary"
      [disabled]="form.invalid"
      (click)="generateQRCode(this.form.value)"
      cdkFocusInitial>
      {{ 'share_dialog.generate_qr' | transloco }}
      @if (loading) {
        <mat-icon>
          <mat-progress-spinner
            diameter="20"
            mode="indeterminate"
            strokeWidth="11%"></mat-progress-spinner>
        </mat-icon>
      }
    </button>
  } @else {
    <button mat-button color="secondary" (click)="copyQRCodeHref()">
      {{ 'share_dialog.copy_link' | transloco }}
    </button>
    @if (!inAppBrowser) {
      <!-- TODO: Make downloading work inside the app -->
      <button mat-button color="secondary" (click)="download(qrCanvas)">
        {{ 'share_dialog.download' | transloco }}
      </button>
    }
  }
  <button mat-button [mat-dialog-close]="true">{{ 'share_dialog.close' | transloco }}</button>
</mat-dialog-actions>
